import { render, staticRenderFns } from "./pns.vue?vue&type=template&id=d1cb1628"
import script from "./pns.vue?vue&type=script&lang=js"
export * from "./pns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports